import nl from '../translations/nl.json';
export default nl;



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/locale-data/nl.js